import React, {Fragment} from 'react'
import moment from 'moment'

import { evaluateStatus, CustomerStatus } from '../../home/misc/CustomerStatus';
import CreditLimit from '../components/CreditLimit'
import CreditLimitBasisCard from '../components/CreditLimitBasisCard';
import Loading from "../../shared/components/misc/Loading";
import OverdueCard from '../../home/components/OverdueCard'
import UnlockImminent from "../../CreditLimit/components/utilization/UnlockImminent"
import UnlockLater from "../../CreditLimit/components/utilization/UnlockLater"
import UnlockSoon from "../../CreditLimit/components/utilization/UnlockSoon"

export default function Logic({
  creditLimit = {},
  overdueRepayments = [],
  loading = true,
  push = () => {},
  user = {}
}) {
  if(loading) { return <Loading /> }
  const status = evaluateStatus(user);
  const statusFilter = [
    CustomerStatus.KYCVerified,
    CustomerStatus.OfferedLoanOffer
  ]

  function remainingDaysToUnlock() {
    const {expected_unlock_date} = creditLimit
    const dateToday = moment().startOf('day');
    const dueDate   = moment(expected_unlock_date, "YYYY-MM-DD");
    return dueDate.diff(dateToday, 'days');
  }

  function renderLogicDependentCard() {
    if(!statusFilter.includes(status)) return null

    const {
      expected_unlock_date,
      is_credit_limit_locked,
      overdue_count
    } = creditLimit
    if(is_credit_limit_locked) {
      if (overdue_count > 0) { return renderOverdueCard() }
      if(expected_unlock_date) {
        const remainingDays = remainingDaysToUnlock()
        if(remainingDays <= 5) { return renderUnlockSoonCard() }
        if(remainingDays > 5) { return renderUnlockLaterCard() }
      }
    }
    return null
  }

  function renderOverdueCard() {
    let defaultProps = {
      overdueRepayments
    }

    defaultProps = {
      ...defaultProps,
      callToActionCopy: 'Contact Us',
      callToActionUrl: 'mailto:support@firstcircle.com',
      headingSubCopy: 'Contact us to settle your payment immediately to avoid more late fees.',
      footerCopy: '*This amount does not include additional fees yet. Contact us to know the exact amount you need to pay.',
      showId: false,
      showOverdueCount: false,
      showTableHeaders: false,
      showViewAllButton: true,
      sortById: false,
    }

    return (<OverdueCard {...defaultProps} />)
  }

  function renderUnlockSoonCard() {
    const {expected_unlock_date} = creditLimit
    return (
      <UnlockImminent>
        <UnlockLater
          unlockDate={expected_unlock_date}
          redirectTo={push}
          url='/apply-now'
        />
        <UnlockSoon
          unlockDate={expected_unlock_date}
          redirectTo={push}
          url='/apply-now'
        />
      </UnlockImminent>
    );
  }

  function renderUnlockLaterCard() {
    const {expected_unlock_date} = creditLimit
    return (
      <UnlockLater
        unlockDate={expected_unlock_date}
        redirectTo={push}
        url="/apply-now"
      />
    );
  }

  return (
    <Fragment>
      { renderLogicDependentCard() }
      <div className="ds-card" data-testid="account-card">
        { !!statusFilter.includes(status) &&
            <Fragment>
              <CreditLimit creditLimit={creditLimit} />
              <CreditLimitBasisCard />
            </Fragment>
        }
      </div>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/features/account/containers/Logic.js